import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { ArrowsRotateIcon } from '@repo/icons';
import { Button } from '@repo/ui';

interface Props {
  testId: TestId;
  secondsLeft: number;
  pending: boolean;
  onClick: () => void;
  email?: string;
}

export default function CodeResendButton({ testId, secondsLeft, pending, onClick, email }: Props) {
  return (
    <Button
      color="secondary"
      onClick={onClick}
      disabled={secondsLeft > 0}
      testId={testId}
      leftIcon={ArrowsRotateIcon}
      pending={pending}
    >
      <div className="text-center font-normal">
        {tr('auth:login_drawer.auth_code.resend_code')}
        {secondsLeft > 0 && ` (${secondsLeft}s)`}
        {email !== undefined && (
          <>
            <br />
            {email}
          </>
        )}
      </div>
    </Button>
  );
}
